import { Link } from "wouter";
import { SEOHead } from "../components/SEOHead";
import { FooterPixCapture } from "../components/FooterPixCapture";
import { Phone, Calendar, Clock } from "lucide-react";

export default function PixCaptureExpertCall() {
  return (
    <div className="min-h-screen bg-[var(--color-white)] flex flex-col">
      <SEOHead
        title="Experten-Call buchen – pixcapture.app"
        description="Buchen Sie einen kostenlosen Beratungstermin mit unserem Experten-Team"
        path="/expert-call"
      />

      <header className="border-b border-[var(--color-light-grey)]">
        <div className="max-w-[1200px] mx-auto px-8 py-6">
          <Link href="/">
            <h1 className="text-[24px] font-medium tracking-[0.05em] cursor-pointer text-[var(--color-black)] leading-none hover:text-[var(--color-grey)] transition-colors">
              pixcapture.app
            </h1>
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-[800px] mx-auto px-8 py-16 md:py-24">
          <div className="text-center mb-12">
            <Phone className="h-16 w-16 mx-auto mb-4 text-[var(--color-accent)]" />
            <h2 className="mb-4">Kostenloser Experten-Call</h2>
            <p className="text-[var(--color-grey)]">
              Lassen Sie sich von unserem Team persönlich beraten
            </p>
          </div>

          <div className="bg-[var(--color-white)] border border-[var(--color-light-grey)] rounded-lg p-8">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Calendar className="h-6 w-6 text-[var(--color-accent)] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="mb-2">Termin wählen</h3>
                  <p className="text-[var(--color-grey)] text-[14px]">
                    Wählen Sie einen passenden Termin aus unserem Kalender
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock className="h-6 w-6 text-[var(--color-accent)] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="mb-2">30 Minuten</h3>
                  <p className="text-[var(--color-grey)] text-[14px]">
                    Ausführliche Beratung zu allen Funktionen
                  </p>
                </div>
              </div>

              <div className="pt-6 border-t border-[var(--color-light-grey)]">
                <p className="text-center text-[var(--color-grey)] mb-4">
                  Buchungssystem wird geladen...
                </p>
                <div className="h-[400px] bg-[var(--color-white)] border-2 border-dashed border-[var(--color-light-grey)] rounded-lg flex items-center justify-center">
                  <p className="text-[var(--color-grey)]">Calendly Integration</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <FooterPixCapture />
    </div>
  );
}
